// extracted by mini-css-extract-plugin
module.exports =  {"modalWidth":"564px","modal":"modal--li2n7","footer":"footer--tpzIe","close-btn":"close-btn--D6Dk7","closeBtn":"close-btn--D6Dk7"};